import { render, staticRenderFns } from "./BasicForms.vue?vue&type=template&id=45599296"
import script from "./BasicForms.vue?vue&type=script&lang=js"
export * from "./BasicForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports